import styled from 'styled-components';

export const Line = styled.div<{ $color?: string }>`
  height: 1px;
  margin: 20px 0;
  background: linear-gradient(
    90deg,
    rgba(56, 55, 50, 0) 0%,
    ${props => props.$color || '#6d6250'} 51.04%,
    rgba(56, 55, 50, 0) 100%
  );
`;
